export const toBase64 = (file?: Blob | null): Promise<string> | null => {
  if (!file) {
    return null;
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

const FILENAME_FOLDERS = {
  complex: 'complexes',
  field: 'fields',
};

/**
 * Returns the stored file name of an uploaded image, e.g.
 * https://<bucket>.s3.<region>.amazonaws.com/<env>/complexes/12/<file name>.
 * Works for any bucket, region and environment folder.
 */
export const getFileNameFromUrl = (url: string, type: 'complex' | 'field') => {
  let pathname: string;

  try {
    pathname = new URL(url).pathname;
  } catch {
    return '';
  }

  const segments = pathname.split('/').filter(Boolean).map(decodeURIComponent);
  const folderIndex = segments.lastIndexOf(FILENAME_FOLDERS[type]);

  if (folderIndex >= 0 && segments.length === folderIndex + 3) {
    return segments[folderIndex + 2];
  }

  return segments[segments.length - 1] || '';
};
